import React, { Component } from 'react';

export default class Towsif extends Component {
    render() {
        return (
            <div className="container">
            <div className="row">
                <div className="col-10 mx-auto text-center text-uppercase pt-5">
                    <h6>Developed by-</h6>
                    <h3 className="text-blue text-title">Mohammad Towsif Patwary</h3>
                    <h4>Software Developer</h4>
                    <p>Mobile: +8801670115405<br/>Email: mdtowsif03@gmail.com</p>
                </div>
            </div>
        </div>
        );
    }
}
